import { props } from '@ngrx/store';
import { MappingField } from '../../modules/version/version-mapping-data.model';
import { createNonUndoableAction } from './utils/action-utils';

export const designerLoadMappingFields = createNonUndoableAction('[Designer] Load Mapping Fields', props<{ versionId: string }>());
export const designerUpdateMappingFields = createNonUndoableAction('[Designer] Update Mapping Fields', props<{ mappings: MappingField[] }>());
